import { ApiResponse, httpClient } from '@/utils';
import {
  BlogPostEndpoints,
  IBlogCategoriesListResponse,
  IBlogMediaUploadResponse,
  IBlogPostDetailResponse,
  IBlogPostListQueryDTO,
  IBlogPostsListResponse,
  IBlogPostStorePayload,
} from '@/models/blog-post.model';

class ContentPagesAPI {
  static list(params?: IBlogPostListQueryDTO): ApiResponse<IBlogPostsListResponse> {
    return httpClient.get<IBlogPostsListResponse>(BlogPostEndpoints.BLOG_POSTS, { params });
  }

  static getById(uuid: string): ApiResponse<IBlogPostDetailResponse> {
    return httpClient.get<IBlogPostDetailResponse>(`${BlogPostEndpoints.BLOG_POST}/${uuid}`);
  }

  static create(payload: IBlogPostStorePayload): ApiResponse<IBlogPostDetailResponse> {
    return httpClient.post<IBlogPostDetailResponse>(BlogPostEndpoints.BLOG_POST, payload);
  }

  static update(uuid: string, payload: IBlogPostStorePayload): ApiResponse<IBlogPostDetailResponse> {
    return httpClient.patch<IBlogPostDetailResponse>(`${BlogPostEndpoints.BLOG_POST}/${uuid}`, payload);
  }

  static setPublished(uuid: string, published: boolean): ApiResponse<unknown> {
    return httpClient.patch(`${BlogPostEndpoints.BLOG_POST}/${uuid}/published`, { published });
  }

  static save(uuid: string): ApiResponse<IBlogPostDetailResponse> {
    return httpClient.post<IBlogPostDetailResponse>(`${BlogPostEndpoints.BLOG_POST}/${uuid}/save`);
  }

  static listBlogCategories(): ApiResponse<IBlogCategoriesListResponse> {
    return httpClient.get<IBlogCategoriesListResponse>(BlogPostEndpoints.BLOG_CATEGORIES);
  }

  static revert(uuid: string): ApiResponse<IBlogPostDetailResponse> {
    return httpClient.post<IBlogPostDetailResponse>(`${BlogPostEndpoints.BLOG_POST}/${uuid}/revert`);
  }

  static delete(uuid: string): ApiResponse<unknown> {
    return httpClient.delete(`${BlogPostEndpoints.BLOG_POST}/${uuid}`);
  }

  static uploadBlogMedia(file: File): ApiResponse<IBlogMediaUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    return httpClient.post<IBlogMediaUploadResponse>(BlogPostEndpoints.BLOG_MEDIA, formData);
  }
}

export default ContentPagesAPI;
